import React from "react";
import { HeroCardWrapper, CodeCardWrapper } from "./HeroSectionElement";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";

export const CodeCard = () => {
  const age = new Date().getFullYear() - 1997;
  // trimed down polyfill of String.repeat

  const { mode } = React.useContext(ThemeContext);

  return (
    <CodeCardWrapper id="code" props={mode}>
      <pre>
        1&nbsp;&nbsp;class <b>Person</b> {"{"}
      </pre>
      <pre>2&nbsp;&nbsp;&nbsp; constructor() {"{"}</pre>
      <pre>
        3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; this.name = "<b>Rohan Kumar Baranwal</b>
        ";
      </pre>
      <pre>
        4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; this.traits = "
        <b>FULL-STACK DEVELOPER</b>";
      </pre>
      <pre>5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; this.age = {age} ;</pre>
      <pre>6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {"}"}</pre>
      <pre>7&nbsp;&nbsp;{"}"}</pre>
    </CodeCardWrapper>
  );
};
const HeroSection = () => {
  return (
    <HeroCardWrapper>
      <CodeCard />
    </HeroCardWrapper>
  );
};

export default HeroSection;
